const usefulLinkInputFields = [
  {
    name: 'name',
    label: 'Nome',
  },
  {
    name: 'description',
    label: 'Descrição',
    width: 120,
  },
  {
    name: 'theme',
    label: 'Tema',
    width: 120,
  },
  {
    name: 'url',
    label: 'URL',
    width: 120,
  },
  {
    name: 'login',
    label: 'Login',
    width: 120,
  },
  {
    name: 'password',
    label: 'Senha',
    width: 120,
  },
];

export default usefulLinkInputFields;
